/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateGiftCardPaymentIntentInput = {
  readonly assetId: string;
  readonly balance: number;
  readonly deliveryDateTime?: string | null | undefined;
  readonly deliveryMethods: ReadonlyArray<string>;
  readonly isAsap: boolean;
  readonly message?: string | null | undefined;
  readonly paymentMethodId: string;
  readonly quantity: number;
  readonly recipientEmail?: string | null | undefined;
  readonly recipientName: string;
  readonly senderName: string;
  readonly shouldSetupFutureUsage?: boolean | null | undefined;
  readonly utcOffset: number;
};

export type CreateGiftCardPaymentIntentMutationVariables = Exact<{
  input: Types.CreateGiftCardPaymentIntentInput;
}>;

export type CreateGiftCardPaymentIntentMutation = {
  readonly createGiftCardPaymentIntent: {
    readonly __typename: 'PaymentIntent';
    readonly id: string;
    readonly secret: string;
    readonly orderId: string;
  };
};

export const CreateGiftCardPaymentIntentDocument = gql`
  mutation CreateGiftCardPaymentIntent($input: CreateGiftCardPaymentIntentInput!) {
    createGiftCardPaymentIntent(input: $input) {
      __typename
      id
      secret
      orderId
    }
  }
`;

export function useCreateGiftCardPaymentIntentMutation() {
  return Urql.useMutation<
    CreateGiftCardPaymentIntentMutation,
    CreateGiftCardPaymentIntentMutationVariables
  >(CreateGiftCardPaymentIntentDocument);
}
